import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import Slider, { Range } from 'rc-slider';
import SpanNcBarPrice from '../common/price/SpanNcBarPrice';
import SpanNcInfoPrice from '../common/price/SpanNcInfoPrice';
import { setStMinPriceAction, setStMaxPriceAction, setStCurPriceAction, setStCurMINMAXPriceAction, setStPriceFilterChangeAction, setStFilterChangeAction } from '../../modules/st/stContentsModule';
import TagBtn from '../common/button/TagBtn';

import {isMobileOnly} from 'react-device-detect';

const SpacePriceFilterBlock = styled.div`
   ${isMobileOnly&&
`   .tf-list {
                display:flex; 
                align-items:
                flex-start; 
                height:5rem;
                
                .price-label-all {width:20vw;}
                
                .num_control-wrap {
                    width:72vw;
                    .num_control-box {display:flex; flex-direction:column;}                    
                }
                
             }
   `} 
`;

const SpacePriceFilter = () => {

    const dispatch = useDispatch();
    const [curPrice, setCurPrice] = useState([0, 9000000]);

    const { curPriceRedux, curMinMaxPrice, stItems, priceFilterChange, filterChange } = useSelector(
        ({ stContentsReducer}) => ({
            curPriceRedux: stContentsReducer.curPrice,
            curMinMaxPrice: stContentsReducer.curMinMaxPrice,
            priceFilterChange: stContentsReducer.priceFilterChange,
            stItems: stContentsReducer.stItems,
            filterChange: stContentsReducer.filterChange,
        }));

    useEffect(() => {
        if (stItems !== null) {

            if (priceFilterChange) {
                dispatch(setStPriceFilterChangeAction(false));
            }
            else {

                if(filterChange && stItems.length > 0 && stItems[0].space_total_min_price !== undefined && stItems[0].space_total_min_price !== null ){
                    let minPrice = Math.floor(stItems[0].space_total_min_price / 10000) * 10000;
                    let maxPrice = Math.floor(stItems[0].space_total_max_price / 10000) * 10000;// + 10000;
                    if (maxPrice === stItems[0].space_total_max_price) {

                    }
                    else {
                        maxPrice += 10000;
                    }
                    //console.log('stitems = ' + JSON.stringify(stItems))
                    //console.log('maxprice = ' +maxPrice )
                    //console.log('minPrice = ' +minPrice )
                    dispatch(setStPriceFilterChangeAction(false));
                    dispatch(setStCurMINMAXPriceAction([minPrice, maxPrice]));
                    dispatch(setStCurPriceAction([minPrice, maxPrice]));
                    setCurPrice([minPrice, maxPrice]);
                    dispatch(setStFilterChangeAction(false));
                } else {
                    setCurPrice([curPriceRedux[0], curPriceRedux[1]]);
                }


            }
        }

    }, [stItems])

    const handleChange = (value) => {
        setCurPrice(value);
        //dispatch(setStCurPriceAction(value));
    }

    const handleAfterChange = (value) => {
        //console.log("handleAfterChange : " + value);

        // 서버에 요청 하기
        let arrPrice = value.splice(',');
        /* if (value[0] !== arrPrice[0]) {
            dispatch(setStMinPriceAction(arrPrice[0]));
        }

        if (value[1] !== arrPrice[1]) {
            dispatch(setStMaxPriceAction(arrPrice[1]));
        } */
        dispatch(setStPriceFilterChangeAction(true));
        setCurPrice([arrPrice[0],arrPrice[1]]);
        dispatch(setStCurPriceAction([arrPrice[0],arrPrice[1]]));
    }

    const onClickAll = () => {
        //setCurPrice([curMinPrice,curMaxPrice])
        if (isFilterAll()) {
            return;
        }
        /* setCurPrice([0, 9000000])
        dispatch(setStMinPriceAction(0));
        dispatch(setStMaxPriceAction(9000000)); */
        dispatch(setStPriceFilterChangeAction(true));
        setCurPrice(curMinMaxPrice);
        dispatch(setStCurPriceAction([curMinMaxPrice[0],curMinMaxPrice[1] ]));
    }

    const isFilterAll = () => {
        if (curMinMaxPrice[0] === curPrice[0] && curMinMaxPrice[1] === curPrice[1]) {
            return true;
        }

        return false;
    }
    const handleCateClickNoAction = (cateid) => { }

    return (
        <SpacePriceFilterBlock>
            <div className="tf-item clearfix">
                <span className="tf-title">가격</span>
                <ul className="tf-list clearfix">
                    <li onClick={onClickAll}  className="price-label-all" style={{ marginTop: '16px' }}>
                        <TagBtn active={isFilterAll()}
                            float='left' onClick={handleCateClickNoAction}
                            onDelClick={handleCateClickNoAction}
                            text={"전체"} isSmall={true} value={false}
                            noDelBtn={isFilterAll() === true ? "true" : "false"}
                        />
                    </li>
                    <li>
                        <div className="num_control-wrap">
                            <div className="num_control-box clearfix">
                                <div className="nc_bar">
                                    {
                                        <Range min={curMinMaxPrice[0]} max={curMinMaxPrice[1]}
                                            defaultValue={curPrice}
                                            value={curPrice}
                                            step="10000"
                                            trackStyle={[{ backgroundColor: '#ffe7ad' }]}
                                            handleStyle={[{ borderColor: '#ffc742' }, { borderColor: '#ffc742' }]}
                                            onChange={handleChange}
                                            onAfterChange={handleAfterChange}
                                            allowCross={false} />
                                    }
                                    <span className="nc_bar-value gray"></span>
                                    <span className="nc_bar-value current"></span>
                                    <SpanNcBarPrice value={curMinMaxPrice[0]} isMax={false} />
                                    <SpanNcBarPrice value={curMinMaxPrice[1]} isMax={true} />
                                </div>

                                <SpanNcInfoPrice
                                    minValue={curPrice[0] === 0 ? curMinMaxPrice[0] : curPrice[0]}
                                    maxValue={curPrice[1] === 0 ? curMinMaxPrice[1] : curPrice[1]} />

                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </SpacePriceFilterBlock>
    );
};

export default SpacePriceFilter;
